// import { isProgrammaticAdsWandComEnabled } from '@repo/feature-flags/check-feature';
import type { FeatureFlags } from '@repo/wemod-api/features/schema';
import type { WandAnalyticsParams } from '@repo/wemod-api-client/analytics/analytics-cookie';

export function isAdEligible(params: WandAnalyticsParams | null): boolean {
    if (!params) {
        return true;
    }

    return params.adElig !== 0;
}

export function shouldShowAdSlot(
    params: WandAnalyticsParams | null,
    _flags: FeatureFlags,
    previewMode: boolean,
): boolean {
    // Temporarily ignore feature flag check due to API throttling for anonymous wand.com visitors:
    // https://linear.app/wemod/issue/WAND-7058/try-to-forward-cf-ip-headers-during-wandcom-ssr-api-requests
    // return previewMode || (isAdEligible(params) && isProgrammaticAdsWandComEnabled(flags));
    return previewMode || isAdEligible(params);
}
